module.exports = __webpack_public_path__ + "img/new-zealand.262bdd4f.svg";